import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useAccountChange = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])

  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await RequestService.getAccountChangeData()
      setData(data || [])
    } catch (e) {
      console.log('useAccountChange', e)
    }

    setLoading(false)
  })

  useEffect(() => {
    fetchData()
  }, [])

  return {
    loading,
    data,
  }
}

export default useAccountChange
